import { Card, styled } from '@mui/material';

export const DashboardCard = styled(Card)({
  border: '1px solid #d7d7d7',
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
})
